import React, { FC, useEffect, useMemo } from 'react';
import {
  generatePath, useHistory, useParams,
} from 'react-router-dom';
import DashboardHeader from '../../../components/DashboardHeader';
import CustomerTabs from '../CustomerTabs';
import { AdminRouteName } from '../../CONSTANTS';
import AdminTable from '../../../components/AdminTable';
import useGetQueryParams from '../../../customHooks/useGetQueryParams';
import useCustomQuery from '../../../network/useCustomQuery';
import { GET_ALL_CUSTOMERS } from '../../../graphql/admin_queries';
// import useToast from '../../../customHooks/useToast';
import EmptyRecord from '../../../components/EmptyRecord';
import useTableColumn from '../../../customHooks/useTableColumn';
import { cleanUpProductPreference } from '../../../utils/helpers';
import EmptyMerchantSettlement from '../../../svgs/EmptyMerchantSettlement';

const LIMIT = 14;

const ProductPreferenceDistribution: FC = () => {
  const columns = [
    ['image', 'email', 'hasBottomValue', 'name'],
    'apartment_search',
    'rent_payment',
    'pre_rent_guarantee',
    'rent_guarantee',
    'status',
  ];
  const columnsTitle = {
    name: 'Customer',
    apartment_search: 'Apartment Search',
    rent_payment: 'Rent Payment',
    pre_rent_guarantee: 'Pre-rent Guarantee',
    rent_guarantee: 'Rent Guarantee',
    status: 'Status',
  };

  const { getQuery } = useGetQueryParams();
  const { status } = useParams<{status: string}>();
  const page = Number(getQuery('page') || '1');
  const search = getQuery('search') || '';
  const { push } = useHistory();
  // const Toast = useToast();
  const {
    getColumns,
    // applyChanges,
    // selectedColumns,
  } = useTableColumn(columns, columnsTitle);

  const [getCustomers, loading, rawResponse] = useCustomQuery({
    query: GET_ALL_CUSTOMERS,
    onError: () => {},
    onData: () => {},
  });

  const onPageLoad = async (offset, limit = LIMIT) => getCustomers({
    variables: {
      offset,
      limit,
      search,
      product: status,
    },
  });

  useEffect(() => {
    onPageLoad((page - 1) * LIMIT);
  }, [page]);

  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };

  const extractData = (response: any) => {
    if (response) {
      return response.usersCa;
    }
  };

  const data = extractData(rawResponse);

  const rawData = useMemo(() => cleanUpProductPreference(data?.users), [rawResponse]);

  const tabs = [
    {
      name: 'All', link: AdminRouteName.customerProductPreferenceRoute, count: data?.count,
    },
    {
      name: 'Apartment Search', link: generatePath(AdminRouteName.customerProductPreferenceStatusRoute, { status: 'apartment_search' }), count: data?.count,
    },
    {
      name: 'Rent Payment', link: generatePath(AdminRouteName.customerProductPreferenceStatusRoute, { status: 'rent_payment' }), count: data?.count,
    },
    {
      name: 'Pre-rent Guarantee', link: generatePath(AdminRouteName.customerProductPreferenceStatusRoute, { status: 'pre_rent_guarantee' }), count: data?.count,
    },
    {
      name: 'Rent Guarantee', link: generatePath(AdminRouteName.customerProductPreferenceStatusRoute, { status: 'rent_guarantee' }), count: data?.count,
    },
  ];

  return (
    <>
      <DashboardHeader
        title="Customers"
        searchPlaceholder="Customer name / Email address"
        // search={search}
        // onSearchChange={onSearchChange}
        // searchLoading={loading}
      >
        <CustomerTabs Tabs={tabs} />
      </DashboardHeader>
      <div className="product-preference-table-details-cover">
        {data?.count ? (
          <AdminTable
            refreshing={loading}
            page={page}
            setPage={setPage}
            pageSize={LIMIT}
            minHeight="calc(100vh - 280px)"
            count={data?.count}
            contents={rawData}
            reference="id"
            // hideDominantImage
            clickable
            hasNameAndImage
            handleClick={
              (data) => push(
                `/customers/customer-details/${data.id}/profile`,
              )
            }
            allowKeyArr={getColumns(true)}
            mobileAllowKeyArr={
              [
                'status',
                ['amount', 'name'],
                ['dateApplied', 'dateCompleted'],
              ]
            }
            formatLabels={columnsTitle}
          />
        ) : (
          <EmptyRecord
            height="calc(100vh - 240px)"
            title="No Data"
            main="Customer Product Preference will appear here on the dashboard."
            // footer="Receive Payments"
            loading={loading}
            Icon={EmptyMerchantSettlement}
          />
        )}
      </div>
    </>
  );
};

export default ProductPreferenceDistribution;
